import { useEffect } from "react";

const useAutoUpdate = () => {
  useEffect(() => {
    const checkForUpdate = async () => {
      try {
        const response = await fetch("/version.json?t=" + Date.now());
        const { version } = await response.json();
        const currentVersion = localStorage.getItem("app-version");

        if (!currentVersion) {
          // First load - store version
          localStorage.setItem("app-version", version);
        } else if (currentVersion !== version) {
          // New version - reload
          console.log("🔄 New version found, updating...");
          localStorage.setItem("app-version", version);
          window.location.reload();
        }
      } catch (error) {
        console.log("Version check failed");
      }
    };

    // Check every 2 minutes
    const interval = setInterval(checkForUpdate, 2 * 60 * 1000);

    // Check immediately
    checkForUpdate();

    return () => clearInterval(interval);
  }, []);
};

export default useAutoUpdate;
